import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SDQTeacherParent',
    label: 'SDQTeacherParent',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
